import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ContactUsHomeForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return regex.test(String(email).trim());
  };

  const validateMobile = (mobile) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(mobile);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateEmail(formData.email)) {
    alert("Please enter a valid email address.");
    return;
  }

  if (!validateMobile(formData.mobile)) {
    alert("Please enter a valid 10 digits mobile number ");
    return;
  }

  setLoading(true);

  // ✅ Build ERP payload from your current form fields
 const erpPayload = {
  Title: "Mr",                    // REQUIRED by backend
  clientname: formData.name,
  mobilenumber: formData.mobile,
  email: formData.email,
  location: "",
  customercomments: formData.message,
  // projectname: "SHADES OF GREEN", // REQUIRED by backend
  projectname: "Shades of Green - Marketing Office",
};


  try {
    // ✅ Send to your existing endpoint + StrategicERP in one submit
    const results = await Promise.allSettled([
      axios.post(`${API_BASE_URL}/home/contact`, formData),
      axios.post(`${API_BASE_URL}/erp/submit-lead`, erpPayload),
    ]);

    const websiteOk = results[0].status === "fulfilled";
    const erpOk = results[1].status === "fulfilled";

    if (!websiteOk) {
      console.error("❌ Website form failed:", results[0].reason);
      alert("Something went wrong while sending your message.");
      return;
    }

    // Website success message stays true even if ERP fails (recommended)
    if (!erpOk) {
      console.error("⚠️ ERP push failed:", results[1].reason);
    }

    alert("Thank you for reaching out! We’ll get back to you within 24 hours.");
    console.log("✅ Contact form submitted successfully");
    setFormData({ name: "", email: "", mobile: "", message: "" });

  } catch (err) {
    console.error("❌ Submission failed:", err);
    alert("Something went wrong while sending your message.");
  } finally {
    setLoading(false);
  }
};

  return (
    <section
      id="quote"
      className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-0"
    >
      <div className="container mx-auto max-w-6xl">
        <div className="rounded-3xl bg-gradient-to-br from-green-50 to-blue-50 p-6 sm:p-10 lg:p-16 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-center">
            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-2xl">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-5 sm:mb-6">
                Send us a message
              </h3>

              <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
                <input
                  type="text"
                  name="name"
                  placeholder="Full name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-3 sm:p-3.5 border-2 border-gray-200 rounded-lg focus:border-blue-500 outline-none text-sm sm:text-base"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 sm:p-3.5 border-2 border-gray-200 rounded-lg focus:border-blue-500 outline-none text-sm sm:text-base"
                  required
                />
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  className="w-full p-3 sm:p-3.5 border-2 border-gray-200 rounded-lg focus:border-blue-500 outline-none text-sm sm:text-base"
                  required
                />
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full p-3 sm:p-3.5 border-2 border-gray-200 rounded-lg focus:border-blue-500 outline-none text-sm sm:text-base"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-2.5 sm:py-3 rounded-lg font-semibold text-sm sm:text-base hover:from-blue-600 hover:to-blue-700 shadow-lg transition-all"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            </div>

            <div className="text-center lg:text-left max-w-md mx-auto lg:mx-0">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 sm:mb-6">
                Ready to Visit a Site?
              </h2>
              <p className="text-gray-600 text-base sm:text-lg mb-6 sm:mb-8">
                Book a walkthrough and experience our construction quality
                firsthand.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsHomeForm;
